var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178.106,
    height: 64.699,
    viewBox: "0 0 178.106 64.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1000001663",
    "data-name": "Group 1000001663",
    transform: "translate(114 -51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-114 51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,6.192c3.6,2.353,4.64,4.111,11.346,7.2s13.408.287,18.952-.871c6.5-1.357,8.375-5.46,1.965-3.644S20.332,9.257,18.3,8.125s-5.9-2.932.573-1.788,8.141-1.5,4.554-2.028S17.423,1.144,10.713.1C5.347-.734,1.229,3.795,0,6.192Z",
    transform: "translate(1.203 36.609)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.366,39.311,1.209,42.8C.673,41.918.148,40.157.025,36.633-.094,33.21.245,17,.288,9.318A1.1,1.1,0,0,1,.947,8.31C1.605,8.059,28.025-.19,28.427,0,29.208.38,50.778,6.17,56.039,8.31c.525.213.79.631.79,2.14.009.631-.163,8.353-.154,9.063-.131,3.3-.211,22.022-.51,22.53-1.258,2.14-1.534,6.049-12.613,14.348-7.388,5.536-13.237,7.8-14.988,8.307-9.228-3.781-16.722-9.421-21.589-13.092l8.287,2.582C27.1,60.4,26.038,59.788,28.4,60.669c15.119-6.421,21.589-15.6,23.56-18.626.485-.74.741-14.883.912-18L52.754,11.2C44.909,8.979,29.06,4.633,28.43,4.532S12.128,8.895,4.368,11.2l0,0Z",
    transform: "translate(0)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,.69H7.066A6.992,6.992,0,0,1,8.958.935a3.728,3.728,0,0,1,1.546.8,3.762,3.762,0,0,1,1.039,1.609,7.492,7.492,0,0,1,.392,2.638A7.091,7.091,0,0,1,11.7,7.931a4,4,0,0,1-.623,1.319,3.154,3.154,0,0,1-.854.826,5.715,5.715,0,0,1-.993.515l3.186,6.638H8.935L6.188,11.1H5.541c-.231-.016-.47-.022-.715-.022H4.087c-.245,0-.47-.008-.67-.022v6.169H0l0,0Z",
    transform: "translate(63.041 20.999)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.628,9.456a2.881,2.881,0,0,0,.831-.112,1.574,1.574,0,0,0,.647-.379,1.826,1.826,0,0,0,.416-.76A3.788,3.788,0,0,0,9.683,7a3.413,3.413,0,0,0-.161-1.14,1.489,1.489,0,0,0-.416-.715,1.378,1.378,0,0,0-.647-.357,2.881,2.881,0,0,0-.831-.112H4.582V9.456Z",
    transform: "translate(61.878 19.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M19.089,2.9V.707a.421.421,0,0,1,.484-.469h2.632a.4.4,0,0,1,.324.134.5.5,0,0,1,.115.335V2.9a.392.392,0,0,1-.439.447H19.573C19.25,3.346,19.089,3.2,19.089,2.9Z",
    transform: "translate(58.197 21.114)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M19.18,6.771H22.6v12H19.18v-12Z",
    transform: "translate(58.174 19.456)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M30.357,18.823q-.668-.021-1.34-.09c-.447-.044-.862-.1-1.247-.156a7.255,7.255,0,0,1-.969-.246V16.388h5.5a3.655,3.655,0,0,0,.785-.068.784.784,0,0,0,.462-.291A1.058,1.058,0,0,0,33.7,15.4v-.379a.841.841,0,0,0-.3-.693,1.819,1.819,0,0,0-1.109-.246h-1.94a5.534,5.534,0,0,1-1.917-.313,2.817,2.817,0,0,1-1.362-1.028,3.374,3.374,0,0,1-.484-1.922v-.693a3.725,3.725,0,0,1,.462-1.922A2.871,2.871,0,0,1,28.6,7.022a8.854,8.854,0,0,1,2.978-.4,15.506,15.506,0,0,1,1.616.09q.878.066,1.639.2a7.21,7.21,0,0,1,1.247.268V9.122H30.886a1.884,1.884,0,0,0-1.016.224.827.827,0,0,0-.346.782v.357a.952.952,0,0,0,.161.6.98.98,0,0,0,.484.268,4.633,4.633,0,0,0,.854.068h1.985a3.779,3.779,0,0,1,2.748.85,3.01,3.01,0,0,1,.878,2.3V15.65a2.9,2.9,0,0,1-.6,1.922,3.291,3.291,0,0,1-1.709,1.006,10.909,10.909,0,0,1-2.725.291l0,0C31.219,18.867,30.8,18.851,30.357,18.823Z",
    transform: "translate(56.293 19.495)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M42.894,0h3.417V9.208h1.455l2.725-4.157h3.463l-3.648,5.656,4.017,6.348H50.861l-3.139-4.85H46.313v4.85H42.9l0,0Z",
    transform: "translate(52.156 21.174)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M68.216.69h7.064a6.992,6.992,0,0,1,1.892.246,3.573,3.573,0,0,1,2.585,2.413,7.492,7.492,0,0,1,.392,2.638,7.091,7.091,0,0,1-.231,1.944A3.964,3.964,0,0,1,79.3,9.25a3.178,3.178,0,0,1-.854.826,5.715,5.715,0,0,1-.993.515l3.186,6.638H77.149L74.4,11.1h-.647c-.231-.016-.47-.022-.715-.022H72.3c-.247,0-.47-.008-.67-.022v6.169H68.216Z",
    transform: "translate(45.731 20.999)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M75.842,9.454a2.881,2.881,0,0,0,.831-.112,1.574,1.574,0,0,0,.647-.379,1.826,1.826,0,0,0,.416-.76A3.788,3.788,0,0,0,77.9,7a3.413,3.413,0,0,0-.161-1.14,1.489,1.489,0,0,0-.416-.715,1.378,1.378,0,0,0-.647-.357,2.889,2.889,0,0,0-.831-.112H72.8V9.454Z",
    transform: "translate(44.569 19.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M88.908,18.307a3.34,3.34,0,0,1-1.777-1.878,10.375,10.375,0,0,1-.532-3.71,11.267,11.267,0,0,1,.507-3.778,3.187,3.187,0,0,1,1.709-1.878,8.127,8.127,0,0,1,3.255-.537,9.942,9.942,0,0,1,2.956.357,2.645,2.645,0,0,1,1.593,1.251,5.176,5.176,0,0,1,.507,2.526,3.262,3.262,0,0,1-.507,1.922,2.733,2.733,0,0,1-1.385,1.006,6.941,6.941,0,0,1-2.123.291H89.994a4.568,4.568,0,0,0,.276,1.475,1.55,1.55,0,0,0,.9.782,6.327,6.327,0,0,0,1.917.224h3.624v1.944q-.9.179-1.985.357a17.782,17.782,0,0,1-2.539.156l0,0A8.6,8.6,0,0,1,88.908,18.307Z",
    transform: "translate(41.066 19.518)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    "data-name": "Vector",
    d: "M93.9,12.728a1.585,1.585,0,0,0,1.016-.268,1.2,1.2,0,0,0,.324-.962,2.152,2.152,0,0,0-.208-1.028,1.126,1.126,0,0,0-.647-.559,3.172,3.172,0,0,0-1.177-.179A2.493,2.493,0,0,0,91.961,10a1.45,1.45,0,0,0-.67.894,6.3,6.3,0,0,0-.208,1.832l0,0Z",
    transform: "translate(39.928 18.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    "data-name": "Vector",
    d: "M103.875,18.047A2.88,2.88,0,0,1,103,15.812V14.738a2.84,2.84,0,0,1,.993-2.235,4.52,4.52,0,0,1,3.094-.894h3.162v-.826a1.805,1.805,0,0,0-.208-.916,1.187,1.187,0,0,0-.785-.537,5.972,5.972,0,0,0-1.709-.179h-3.716V7.229a16.5,16.5,0,0,1,4.963-.671,8.5,8.5,0,0,1,2.632.357,2.965,2.965,0,0,1,1.662,1.229,4.334,4.334,0,0,1,.577,2.415v8.158h-2.7l-.554-1.273a2.306,2.306,0,0,1-.554.4,9.511,9.511,0,0,1-.969.469,7.856,7.856,0,0,1-1.27.379,6.608,6.608,0,0,1-1.455.156h0A3.25,3.25,0,0,1,103.875,18.047Z",
    transform: "translate(36.905 19.51)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-14",
    "data-name": "Vector",
    d: "M109.561,18.755l.6-.134c.216-.06.408-.112.577-.156q.278-.09.439-.156c.124-.044.2-.074.231-.09V15.426l-2.078.134a2.272,2.272,0,0,0-1.34.447,1.328,1.328,0,0,0-.416,1.028v.491a1.352,1.352,0,0,0,.185.738,1.213,1.213,0,0,0,.532.425,2.485,2.485,0,0,0,.762.112v0A3.361,3.361,0,0,0,109.561,18.755Z",
    transform: "translate(35.743 17.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    "data-name": "Vector",
    d: "M122.211,16.607a3.712,3.712,0,0,1-1.5-1.922,10.521,10.521,0,0,1-.484-3.509,13.119,13.119,0,0,1,.416-3.62A3.577,3.577,0,0,1,122.1,5.522a5.157,5.157,0,0,1,2.793-.649,7.974,7.974,0,0,1,1.686.179,10.553,10.553,0,0,1,1.478.379V0h3.44V17.055h-2.886l-.554-1.14a4.347,4.347,0,0,1-.969.649,6.269,6.269,0,0,1-1.177.469,5.125,5.125,0,0,1-1.247.156l0,0A4.774,4.774,0,0,1,122.211,16.607Z",
    transform: "translate(32.533 21.174)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-16",
    "data-name": "Vector",
    d: "M128.266,16.8a6.074,6.074,0,0,0,.946-.447V10.322c-.307-.1-.631-.209-.969-.313a3.679,3.679,0,0,0-1.084-.156,2.88,2.88,0,0,0-1.385.291,1.732,1.732,0,0,0-.738,1.1,8.517,8.517,0,0,0-.231,2.279,8.85,8.85,0,0,0,.208,2.168,1.746,1.746,0,0,0,.715,1.05,2.5,2.5,0,0,0,1.292.291h0A3.3,3.3,0,0,0,128.266,16.8Z",
    transform: "translate(31.371 18.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-17",
    "data-name": "Vector",
    d: "M143.621,18.771a4.14,4.14,0,0,1-1.824-.379,3.607,3.607,0,0,1-1.315-1.074,5.43,5.43,0,0,1-.785-1.766l-2.331-8.785h3.556l1.962,8.114a1.958,1.958,0,0,0,.3.671,1.239,1.239,0,0,0,.392.357,2.907,2.907,0,0,0,.369.134,2.334,2.334,0,0,0,.276.022l2.239-9.3h3.463l-3.694,15.088-1.109,2.213h-2.839Z",
    transform: "translate(28.184 19.457)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-18",
    "data-name": "Vector",
    d: "M6.832,0V6.8H0V0Z",
    transform: "translate(20.834 26.639)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-19",
    "data-name": "Vector",
    d: "M6.832,0V6.8H0V0Z",
    transform: "translate(29.217 26.639)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-20",
    "data-name": "Vector",
    d: "M6.832,0V6.8H0V0Z",
    transform: "translate(20.834 18.605)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-21",
    "data-name": "Vector",
    d: "M6.832,0V6.8H0V0Z",
    transform: "translate(29.217 18.605)",
    fill: "#0086e6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c76c1d61a1ed41c922d97397074c85c9.svg";
export { ForwardRef as ReactComponent };